export enum AlertTriggerTypeEnum {
  SCHEDULED = "SCHEDULED",
}
